import { hubService } from '@/services';
import HubVM from '@/view-model/hub-management/HubVM';
const action = {
    setFilterOption({ commit }, payload) {
        commit('SET_FILTER_OPTION', payload);
    },
    setSortOption({ commit }, payload) {
        commit('SET_SORT_OPTION', payload);
    },
    async getHubList({ state: { filterOption, sortOption }, getters, commit, rootGetters, }) {
        try {
            const isHubSelected = rootGetters['hubSelector/getterIsSubscribeHub'];
            const hubId = isHubSelected ? rootGetters['hubSelector/getterSubscribeHubId'] : null;
            const { pageNumber, pageSizeType } = filterOption;
            // 필터
            const filters = [];
            // 검색
            filters.push(...getters.getterSearchFieldTypeParam);
            // 상태
            filters.push(...getters.getterHubStatusTypeParam);
            const pageSize = Number(pageSizeType);
            const param = {
                pageNumber,
                pageSize,
                filters,
                sortOption,
                hubId,
            };
            const data = await hubService.getHubManagementList(param);
            data.list = data.list.map((hub) => new HubVM(hub));
            commit('GET_HUB_LIST', data);
        }
        catch (error) {
            console.log('[hubManagement/hubList/getHubList]', error);
        }
    },
};
export default action;
